import React from 'react';

import { flagStyles } from '../settings';

const SvgSN = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-4872px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgSN;
